"use strict";
/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARE_TYPE = exports.SHARE_STATUS = exports.SHARE_TARGET_TYPE = exports.PERMISSION_TYPE = exports.FOLDER_ITEM_STATUS = exports.FOLDER_ITEM_TYPE = exports.FOLDER_STATUS = exports.USER_NOTATIONS_TYPE = exports.HUB_SECTION_ITEM_STATUS = exports.NOTATION_TYPE = exports.USER_NOTATIONS_STATUS = exports.EMAIL_TEMPLATE_TYPE = exports.EMAIL_TEMPLATE_STATUS = exports.DOCUMENT_ACCESS_LEVEL = exports.MAPPING_STATUS = exports.CONVERSION_WARNING_CODE = exports.INTEGRATION_TYPE = exports.ASSOCIATED_FILE_STATUS = exports.ASSOCIATED_FILE_TYPE = exports.SYNC_SCOPE = exports.NOTIFICATION_SCOPE = exports.DOCUMENT_VERSION_CHANGE_TYPE = exports.FILE_TYPE = exports.PAGE_GROUP_SOURCE = exports.DOCUMENT_STATUS = exports.CONVERSION_STATUS = exports.NAMED_FILTER_TYPE = exports.EMAIL_REPORT_TYPE = exports.FREQUENCY = exports.HUB_SECTION_TYPE = exports.STANDALONE_FORM_USAGE = exports.CRM_INTEGRATION_TYPE = exports.TENANT_FORM_STATUS = exports.TENANT_FORM_TARGET_TYPE = exports.DATE_RESTRICTION = exports.PERMISSION_EFFECT = exports.CUSTOM_FIELD_ACTION_SKIP = exports.CUSTOM_FIELD_ACTION = exports.CUSTOM_FIELD_USAGE = exports.FIELD_POSITION = exports.CONTROL_TYPE = exports.FIELD_DATA_TYPE = exports.FORMAT_VALIDATION = exports.FIELD_STATUS = exports.TENANT_STATUS = exports.ModelAttributeTypes = exports.USER_ROLE = exports.USER_STATUS = exports.CRMSyncStatus = exports.OBJECT_RECORD_STATUS = void 0;
exports.RelatedSlidePageType = exports.ZENDESK_FEATURE = exports.ModelSortDirection = exports.LangflowStatus = exports.TENANT_LOGO_VARIANCE = exports.DOCUMENT_MAPPING_STATUS = exports.DOCUMENT_MAPPING_ACTION = exports.FORCE_PROPERTY_UPDATE = exports.ATTACHED_FILE_ENTITY_TYPE = exports.BULLETIN_STATUS = exports.PROMPT_STATUS = exports.PROMPT_TYPE = exports.CUSTOM_FORM_RECORD_RELATIONSHIP_MODEL = exports.CUSTOM_FORM_RECORD_STATUS = exports.CUSTOM_FORM_RECORD_ENTITY = exports.HUB_TYPE = exports.TODO_STATUS = exports.HUB_SHARED_FILE_CONTENT_TYPE = exports.HUB_SECTION_STATUS = exports.HUB_STATUS = exports.ATTENDEE_TYPE = exports.MEETING_ATTENDEE_STATUS = exports.MEETING_STATUS = exports.MEETING_TYPE = exports.SENTIMENT = exports.MEETING_CONTENT_TYPE = exports.CONTENT_PRESENTED_STATUS = exports.INTEGRATION_RUN_STATUS = exports.LOG_LEVEL = exports.SHARE_NOTIFICATION_SCOPE = void 0;
var OBJECT_RECORD_STATUS;
(function (OBJECT_RECORD_STATUS) {
    OBJECT_RECORD_STATUS["ACTIVE"] = "ACTIVE";
    OBJECT_RECORD_STATUS["REMOVED"] = "REMOVED";
})(OBJECT_RECORD_STATUS = exports.OBJECT_RECORD_STATUS || (exports.OBJECT_RECORD_STATUS = {}));
var CRMSyncStatus;
(function (CRMSyncStatus) {
    CRMSyncStatus["SYNCED"] = "SYNCED";
    CRMSyncStatus["NOT_SYNCED"] = "NOT_SYNCED";
    CRMSyncStatus["DELETED"] = "DELETED";
})(CRMSyncStatus = exports.CRMSyncStatus || (exports.CRMSyncStatus = {}));
var USER_STATUS;
(function (USER_STATUS) {
    USER_STATUS["ACTIVE"] = "ACTIVE";
    USER_STATUS["DEACTIVATED"] = "DEACTIVATED";
})(USER_STATUS = exports.USER_STATUS || (exports.USER_STATUS = {}));
var USER_ROLE;
(function (USER_ROLE) {
    USER_ROLE["AlucioAdmin"] = "AlucioAdmin";
    USER_ROLE["TenantAdmin"] = "TenantAdmin";
    USER_ROLE["TenantPublisher"] = "TenantPublisher";
    USER_ROLE["TenantViewer"] = "TenantViewer";
    USER_ROLE["TenantViewOnly"] = "TenantViewOnly";
    USER_ROLE["TeamReportViewer"] = "TeamReportViewer";
    USER_ROLE["LeadViewer"] = "LeadViewer";
})(USER_ROLE = exports.USER_ROLE || (exports.USER_ROLE = {}));
var ModelAttributeTypes;
(function (ModelAttributeTypes) {
    ModelAttributeTypes["binary"] = "binary";
    ModelAttributeTypes["binarySet"] = "binarySet";
    ModelAttributeTypes["bool"] = "bool";
    ModelAttributeTypes["list"] = "list";
    ModelAttributeTypes["map"] = "map";
    ModelAttributeTypes["number"] = "number";
    ModelAttributeTypes["numberSet"] = "numberSet";
    ModelAttributeTypes["string"] = "string";
    ModelAttributeTypes["stringSet"] = "stringSet";
    ModelAttributeTypes["_null"] = "_null";
})(ModelAttributeTypes = exports.ModelAttributeTypes || (exports.ModelAttributeTypes = {}));
var TENANT_STATUS;
(function (TENANT_STATUS) {
    TENANT_STATUS["ACTIVE"] = "ACTIVE";
    TENANT_STATUS["INACTIVE"] = "INACTIVE";
    TENANT_STATUS["PURGED"] = "PURGED";
})(TENANT_STATUS = exports.TENANT_STATUS || (exports.TENANT_STATUS = {}));
var FIELD_STATUS;
(function (FIELD_STATUS) {
    FIELD_STATUS["DISABLED"] = "DISABLED";
    FIELD_STATUS["ENABLED"] = "ENABLED";
})(FIELD_STATUS = exports.FIELD_STATUS || (exports.FIELD_STATUS = {}));
var FORMAT_VALIDATION;
(function (FORMAT_VALIDATION) {
    FORMAT_VALIDATION["EMAIL"] = "EMAIL";
    FORMAT_VALIDATION["EMAIL_CSV"] = "EMAIL_CSV";
})(FORMAT_VALIDATION = exports.FORMAT_VALIDATION || (exports.FORMAT_VALIDATION = {}));
var FIELD_DATA_TYPE;
(function (FIELD_DATA_TYPE) {
    FIELD_DATA_TYPE["CATEGORICAL"] = "CATEGORICAL";
    FIELD_DATA_TYPE["MULTICATEGORICAL"] = "MULTICATEGORICAL";
    FIELD_DATA_TYPE["STRING"] = "STRING";
    FIELD_DATA_TYPE["DATE"] = "DATE";
    FIELD_DATA_TYPE["USER_LIST"] = "USER_LIST";
    FIELD_DATA_TYPE["OBJECT"] = "OBJECT";
    FIELD_DATA_TYPE["NUMBER"] = "NUMBER";
})(FIELD_DATA_TYPE = exports.FIELD_DATA_TYPE || (exports.FIELD_DATA_TYPE = {}));
var CONTROL_TYPE;
(function (CONTROL_TYPE) {
    CONTROL_TYPE["SELECT"] = "SELECT";
    CONTROL_TYPE["RADIOLIST"] = "RADIOLIST";
    CONTROL_TYPE["CHECKBOX"] = "CHECKBOX";
    CONTROL_TYPE["CHECKBOXLIST"] = "CHECKBOXLIST";
    CONTROL_TYPE["CRMACCOUNTSEARCHER"] = "CRMACCOUNTSEARCHER";
    CONTROL_TYPE["CRMATTENDEELIST"] = "CRMATTENDEELIST";
    CONTROL_TYPE["INPUT"] = "INPUT";
    CONTROL_TYPE["TEXTAREA"] = "TEXTAREA";
    CONTROL_TYPE["DATEPICKER"] = "DATEPICKER";
    CONTROL_TYPE["USERLIST"] = "USERLIST";
    CONTROL_TYPE["CUSTOM"] = "CUSTOM";
    CONTROL_TYPE["OBJECT"] = "OBJECT";
    CONTROL_TYPE["LABEL"] = "LABEL";
    CONTROL_TYPE["INFO_MESSAGE"] = "INFO_MESSAGE";
    CONTROL_TYPE["DATETIMEPICKER"] = "DATETIMEPICKER";
    CONTROL_TYPE["INPUT_CSV"] = "INPUT_CSV";
})(CONTROL_TYPE = exports.CONTROL_TYPE || (exports.CONTROL_TYPE = {}));
var FIELD_POSITION;
(function (FIELD_POSITION) {
    FIELD_POSITION["LEFT"] = "LEFT";
    FIELD_POSITION["RIGHT"] = "RIGHT";
})(FIELD_POSITION = exports.FIELD_POSITION || (exports.FIELD_POSITION = {}));
var CUSTOM_FIELD_USAGE;
(function (CUSTOM_FIELD_USAGE) {
    CUSTOM_FIELD_USAGE["USER_FILTER"] = "USER_FILTER";
    CUSTOM_FIELD_USAGE["MEETING"] = "MEETING";
    CUSTOM_FIELD_USAGE["DOCUMENT"] = "DOCUMENT";
    CUSTOM_FIELD_USAGE["EMAIL_TEMPLATE_FILTER"] = "EMAIL_TEMPLATE_FILTER";
    CUSTOM_FIELD_USAGE["CONTENT_SHARE"] = "CONTENT_SHARE";
    CUSTOM_FIELD_USAGE["HUB"] = "HUB";
    CUSTOM_FIELD_USAGE["TENANT_FORM"] = "TENANT_FORM";
})(CUSTOM_FIELD_USAGE = exports.CUSTOM_FIELD_USAGE || (exports.CUSTOM_FIELD_USAGE = {}));
var CUSTOM_FIELD_ACTION;
(function (CUSTOM_FIELD_ACTION) {
    CUSTOM_FIELD_ACTION["ARCHIVE"] = "ARCHIVE";
    CUSTOM_FIELD_ACTION["REVOKE"] = "REVOKE";
})(CUSTOM_FIELD_ACTION = exports.CUSTOM_FIELD_ACTION || (exports.CUSTOM_FIELD_ACTION = {}));
var CUSTOM_FIELD_ACTION_SKIP;
(function (CUSTOM_FIELD_ACTION_SKIP) {
    CUSTOM_FIELD_ACTION_SKIP["INTEGRATION"] = "INTEGRATION";
})(CUSTOM_FIELD_ACTION_SKIP = exports.CUSTOM_FIELD_ACTION_SKIP || (exports.CUSTOM_FIELD_ACTION_SKIP = {}));
var PERMISSION_EFFECT;
(function (PERMISSION_EFFECT) {
    PERMISSION_EFFECT["ALLOW"] = "ALLOW";
    PERMISSION_EFFECT["BLOCK"] = "BLOCK";
})(PERMISSION_EFFECT = exports.PERMISSION_EFFECT || (exports.PERMISSION_EFFECT = {}));
var DATE_RESTRICTION;
(function (DATE_RESTRICTION) {
    DATE_RESTRICTION["ONLY_FUTURE"] = "ONLY_FUTURE";
    DATE_RESTRICTION["ONLY_PAST"] = "ONLY_PAST";
})(DATE_RESTRICTION = exports.DATE_RESTRICTION || (exports.DATE_RESTRICTION = {}));
var TENANT_FORM_TARGET_TYPE;
(function (TENANT_FORM_TARGET_TYPE) {
    TENANT_FORM_TARGET_TYPE["API"] = "API";
})(TENANT_FORM_TARGET_TYPE = exports.TENANT_FORM_TARGET_TYPE || (exports.TENANT_FORM_TARGET_TYPE = {}));
var TENANT_FORM_STATUS;
(function (TENANT_FORM_STATUS) {
    TENANT_FORM_STATUS["ACTIVE"] = "ACTIVE";
    TENANT_FORM_STATUS["INACTIVE"] = "INACTIVE";
})(TENANT_FORM_STATUS = exports.TENANT_FORM_STATUS || (exports.TENANT_FORM_STATUS = {}));
var CRM_INTEGRATION_TYPE;
(function (CRM_INTEGRATION_TYPE) {
    CRM_INTEGRATION_TYPE["SALESFORCE"] = "SALESFORCE";
    CRM_INTEGRATION_TYPE["VEEVA"] = "VEEVA";
    CRM_INTEGRATION_TYPE["VEEVA_VAULT"] = "VEEVA_VAULT";
})(CRM_INTEGRATION_TYPE = exports.CRM_INTEGRATION_TYPE || (exports.CRM_INTEGRATION_TYPE = {}));
var STANDALONE_FORM_USAGE;
(function (STANDALONE_FORM_USAGE) {
    STANDALONE_FORM_USAGE["STANDALONE"] = "STANDALONE";
    STANDALONE_FORM_USAGE["MEETINGS"] = "MEETINGS";
})(STANDALONE_FORM_USAGE = exports.STANDALONE_FORM_USAGE || (exports.STANDALONE_FORM_USAGE = {}));
var HUB_SECTION_TYPE;
(function (HUB_SECTION_TYPE) {
    HUB_SECTION_TYPE["TEXTAREA"] = "TEXTAREA";
    HUB_SECTION_TYPE["SHARED_FILES"] = "SHARED_FILES";
    HUB_SECTION_TYPE["TODO_LIST"] = "TODO_LIST";
    HUB_SECTION_TYPE["LINKS"] = "LINKS";
})(HUB_SECTION_TYPE = exports.HUB_SECTION_TYPE || (exports.HUB_SECTION_TYPE = {}));
var FREQUENCY;
(function (FREQUENCY) {
    FREQUENCY["DAILY"] = "DAILY";
    FREQUENCY["WEEKLY"] = "WEEKLY";
    FREQUENCY["MONTHLY"] = "MONTHLY";
})(FREQUENCY = exports.FREQUENCY || (exports.FREQUENCY = {}));
var EMAIL_REPORT_TYPE;
(function (EMAIL_REPORT_TYPE) {
    EMAIL_REPORT_TYPE["DOCUMENT_UPDATE_NOTIFICATION"] = "DOCUMENT_UPDATE_NOTIFICATION";
    EMAIL_REPORT_TYPE["ALL_DOCUMENTS_VIEWED"] = "ALL_DOCUMENTS_VIEWED";
    EMAIL_REPORT_TYPE["DOCUMENT_EXPIRATION_ALERTS"] = "DOCUMENT_EXPIRATION_ALERTS";
})(EMAIL_REPORT_TYPE = exports.EMAIL_REPORT_TYPE || (exports.EMAIL_REPORT_TYPE = {}));
var NAMED_FILTER_TYPE;
(function (NAMED_FILTER_TYPE) {
    NAMED_FILTER_TYPE["SEARCH_QA_HARD_FILTER"] = "SEARCH_QA_HARD_FILTER";
    NAMED_FILTER_TYPE["SEARCH_QA_PRIORITY_DOCS"] = "SEARCH_QA_PRIORITY_DOCS";
    NAMED_FILTER_TYPE["SEARCH_QA_MESSAGING_DOCS"] = "SEARCH_QA_MESSAGING_DOCS";
})(NAMED_FILTER_TYPE = exports.NAMED_FILTER_TYPE || (exports.NAMED_FILTER_TYPE = {}));
var CONVERSION_STATUS;
(function (CONVERSION_STATUS) {
    CONVERSION_STATUS["PENDING"] = "PENDING";
    CONVERSION_STATUS["PROCESSING"] = "PROCESSING";
    CONVERSION_STATUS["PROCESSED"] = "PROCESSED";
    CONVERSION_STATUS["ERROR"] = "ERROR";
})(CONVERSION_STATUS = exports.CONVERSION_STATUS || (exports.CONVERSION_STATUS = {}));
var DOCUMENT_STATUS;
(function (DOCUMENT_STATUS) {
    DOCUMENT_STATUS["ARCHIVED"] = "ARCHIVED";
    DOCUMENT_STATUS["REVOKED"] = "REVOKED";
    DOCUMENT_STATUS["NOT_PUBLISHED"] = "NOT_PUBLISHED";
    DOCUMENT_STATUS["PUBLISHED"] = "PUBLISHED";
    DOCUMENT_STATUS["DELETED"] = "DELETED";
    DOCUMENT_STATUS["ARCHIVED_WITH_VERSIONS"] = "ARCHIVED_WITH_VERSIONS";
    DOCUMENT_STATUS["REVOKED_WITH_VERSIONS"] = "REVOKED_WITH_VERSIONS";
    DOCUMENT_STATUS["DELETED_WITH_VERSIONS"] = "DELETED_WITH_VERSIONS";
})(DOCUMENT_STATUS = exports.DOCUMENT_STATUS || (exports.DOCUMENT_STATUS = {}));
var PAGE_GROUP_SOURCE;
(function (PAGE_GROUP_SOURCE) {
    PAGE_GROUP_SOURCE["USER"] = "USER";
    PAGE_GROUP_SOURCE["DOCUMENT"] = "DOCUMENT";
})(PAGE_GROUP_SOURCE = exports.PAGE_GROUP_SOURCE || (exports.PAGE_GROUP_SOURCE = {}));
var FILE_TYPE;
(function (FILE_TYPE) {
    FILE_TYPE["JPG"] = "JPG";
    FILE_TYPE["JPEG"] = "JPEG";
    FILE_TYPE["XLS"] = "XLS";
    FILE_TYPE["XLSX"] = "XLSX";
    FILE_TYPE["XLSM"] = "XLSM";
    FILE_TYPE["DOC"] = "DOC";
    FILE_TYPE["DOCX"] = "DOCX";
    FILE_TYPE["PDF"] = "PDF";
    FILE_TYPE["PPTX"] = "PPTX";
    FILE_TYPE["PNG"] = "PNG";
    FILE_TYPE["MP4"] = "MP4";
    FILE_TYPE["WEB"] = "WEB";
    FILE_TYPE["HTML"] = "HTML";
    FILE_TYPE["ZIP"] = "ZIP";
})(FILE_TYPE = exports.FILE_TYPE || (exports.FILE_TYPE = {}));
var DOCUMENT_VERSION_CHANGE_TYPE;
(function (DOCUMENT_VERSION_CHANGE_TYPE) {
    DOCUMENT_VERSION_CHANGE_TYPE["MAJOR"] = "MAJOR";
    DOCUMENT_VERSION_CHANGE_TYPE["MINOR"] = "MINOR";
})(DOCUMENT_VERSION_CHANGE_TYPE = exports.DOCUMENT_VERSION_CHANGE_TYPE || (exports.DOCUMENT_VERSION_CHANGE_TYPE = {}));
var NOTIFICATION_SCOPE;
(function (NOTIFICATION_SCOPE) {
    NOTIFICATION_SCOPE["NONE"] = "NONE";
    NOTIFICATION_SCOPE["EMAIL"] = "EMAIL";
    NOTIFICATION_SCOPE["EMAIL_IMMEDIATE"] = "EMAIL_IMMEDIATE";
    NOTIFICATION_SCOPE["EMAIL_IMMEDIATE_WITHDRAWN"] = "EMAIL_IMMEDIATE_WITHDRAWN";
})(NOTIFICATION_SCOPE = exports.NOTIFICATION_SCOPE || (exports.NOTIFICATION_SCOPE = {}));
var SYNC_SCOPE;
(function (SYNC_SCOPE) {
    SYNC_SCOPE["PUBLISHER"] = "PUBLISHER";
    SYNC_SCOPE["VIEWER"] = "VIEWER";
    SYNC_SCOPE["NONE"] = "NONE";
})(SYNC_SCOPE = exports.SYNC_SCOPE || (exports.SYNC_SCOPE = {}));
var ASSOCIATED_FILE_TYPE;
(function (ASSOCIATED_FILE_TYPE) {
    ASSOCIATED_FILE_TYPE["DOCUMENT"] = "DOCUMENT";
    ASSOCIATED_FILE_TYPE["ATTACHED_FILE"] = "ATTACHED_FILE";
})(ASSOCIATED_FILE_TYPE = exports.ASSOCIATED_FILE_TYPE || (exports.ASSOCIATED_FILE_TYPE = {}));
var ASSOCIATED_FILE_STATUS;
(function (ASSOCIATED_FILE_STATUS) {
    ASSOCIATED_FILE_STATUS["ACTIVE"] = "ACTIVE";
    ASSOCIATED_FILE_STATUS["DELETED"] = "DELETED";
})(ASSOCIATED_FILE_STATUS = exports.ASSOCIATED_FILE_STATUS || (exports.ASSOCIATED_FILE_STATUS = {}));
var INTEGRATION_TYPE;
(function (INTEGRATION_TYPE) {
    INTEGRATION_TYPE["VEEVA"] = "VEEVA";
    INTEGRATION_TYPE["BEACON"] = "BEACON";
    INTEGRATION_TYPE["EXPORT_TO_S3"] = "EXPORT_TO_S3";
    INTEGRATION_TYPE["NONE"] = "NONE";
})(INTEGRATION_TYPE = exports.INTEGRATION_TYPE || (exports.INTEGRATION_TYPE = {}));
var CONVERSION_WARNING_CODE;
(function (CONVERSION_WARNING_CODE) {
    CONVERSION_WARNING_CODE["PASSWORD_PROTECTED"] = "PASSWORD_PROTECTED";
})(CONVERSION_WARNING_CODE = exports.CONVERSION_WARNING_CODE || (exports.CONVERSION_WARNING_CODE = {}));
var MAPPING_STATUS;
(function (MAPPING_STATUS) {
    MAPPING_STATUS["HAS_MAPPINGS"] = "HAS_MAPPINGS";
    MAPPING_STATUS["NO_MAPPINGS"] = "NO_MAPPINGS";
})(MAPPING_STATUS = exports.MAPPING_STATUS || (exports.MAPPING_STATUS = {}));
var DOCUMENT_ACCESS_LEVEL;
(function (DOCUMENT_ACCESS_LEVEL) {
    DOCUMENT_ACCESS_LEVEL["TENANT"] = "TENANT";
    DOCUMENT_ACCESS_LEVEL["USER"] = "USER";
})(DOCUMENT_ACCESS_LEVEL = exports.DOCUMENT_ACCESS_LEVEL || (exports.DOCUMENT_ACCESS_LEVEL = {}));
var EMAIL_TEMPLATE_STATUS;
(function (EMAIL_TEMPLATE_STATUS) {
    EMAIL_TEMPLATE_STATUS["DRAFT"] = "DRAFT";
    EMAIL_TEMPLATE_STATUS["ACTIVE"] = "ACTIVE";
    EMAIL_TEMPLATE_STATUS["DEACTIVATED"] = "DEACTIVATED";
    EMAIL_TEMPLATE_STATUS["REMOVED"] = "REMOVED";
})(EMAIL_TEMPLATE_STATUS = exports.EMAIL_TEMPLATE_STATUS || (exports.EMAIL_TEMPLATE_STATUS = {}));
var EMAIL_TEMPLATE_TYPE;
(function (EMAIL_TEMPLATE_TYPE) {
    EMAIL_TEMPLATE_TYPE["HTML"] = "HTML";
    EMAIL_TEMPLATE_TYPE["PLAIN_TEXT"] = "PLAIN_TEXT";
})(EMAIL_TEMPLATE_TYPE = exports.EMAIL_TEMPLATE_TYPE || (exports.EMAIL_TEMPLATE_TYPE = {}));
var USER_NOTATIONS_STATUS;
(function (USER_NOTATIONS_STATUS) {
    USER_NOTATIONS_STATUS["ACTIVE"] = "ACTIVE";
    USER_NOTATIONS_STATUS["DELETED"] = "DELETED";
})(USER_NOTATIONS_STATUS = exports.USER_NOTATIONS_STATUS || (exports.USER_NOTATIONS_STATUS = {}));
var NOTATION_TYPE;
(function (NOTATION_TYPE) {
    NOTATION_TYPE["PAGE_BOOKMARK"] = "PAGE_BOOKMARK";
    NOTATION_TYPE["CALLOUT"] = "CALLOUT";
    NOTATION_TYPE["PAGE_NOTE"] = "PAGE_NOTE";
    NOTATION_TYPE["TEXT_INSERTION"] = "TEXT_INSERTION";
})(NOTATION_TYPE = exports.NOTATION_TYPE || (exports.NOTATION_TYPE = {}));
var HUB_SECTION_ITEM_STATUS;
(function (HUB_SECTION_ITEM_STATUS) {
    HUB_SECTION_ITEM_STATUS["ACTIVE"] = "ACTIVE";
    HUB_SECTION_ITEM_STATUS["DELETED"] = "DELETED";
})(HUB_SECTION_ITEM_STATUS = exports.HUB_SECTION_ITEM_STATUS || (exports.HUB_SECTION_ITEM_STATUS = {}));
var USER_NOTATIONS_TYPE;
(function (USER_NOTATIONS_TYPE) {
    USER_NOTATIONS_TYPE["DOCUMENT_VERSION"] = "DOCUMENT_VERSION";
    USER_NOTATIONS_TYPE["CUSTOM_DECK"] = "CUSTOM_DECK";
})(USER_NOTATIONS_TYPE = exports.USER_NOTATIONS_TYPE || (exports.USER_NOTATIONS_TYPE = {}));
var FOLDER_STATUS;
(function (FOLDER_STATUS) {
    FOLDER_STATUS["ACTIVE"] = "ACTIVE";
    FOLDER_STATUS["ARCHIVED"] = "ARCHIVED";
    FOLDER_STATUS["REMOVED"] = "REMOVED";
})(FOLDER_STATUS = exports.FOLDER_STATUS || (exports.FOLDER_STATUS = {}));
var FOLDER_ITEM_TYPE;
(function (FOLDER_ITEM_TYPE) {
    FOLDER_ITEM_TYPE["FOLDER"] = "FOLDER";
    FOLDER_ITEM_TYPE["DOCUMENT_VERSION"] = "DOCUMENT_VERSION";
    FOLDER_ITEM_TYPE["CUSTOM_DECK"] = "CUSTOM_DECK";
})(FOLDER_ITEM_TYPE = exports.FOLDER_ITEM_TYPE || (exports.FOLDER_ITEM_TYPE = {}));
var FOLDER_ITEM_STATUS;
(function (FOLDER_ITEM_STATUS) {
    FOLDER_ITEM_STATUS["ACTIVE"] = "ACTIVE";
    FOLDER_ITEM_STATUS["REMOVED"] = "REMOVED";
})(FOLDER_ITEM_STATUS = exports.FOLDER_ITEM_STATUS || (exports.FOLDER_ITEM_STATUS = {}));
var PERMISSION_TYPE;
(function (PERMISSION_TYPE) {
    PERMISSION_TYPE["VIEW"] = "VIEW";
    PERMISSION_TYPE["EDIT"] = "EDIT";
})(PERMISSION_TYPE = exports.PERMISSION_TYPE || (exports.PERMISSION_TYPE = {}));
var SHARE_TARGET_TYPE;
(function (SHARE_TARGET_TYPE) {
    SHARE_TARGET_TYPE["USER"] = "USER";
    SHARE_TARGET_TYPE["FILTER"] = "FILTER";
    SHARE_TARGET_TYPE["ALL"] = "ALL";
})(SHARE_TARGET_TYPE = exports.SHARE_TARGET_TYPE || (exports.SHARE_TARGET_TYPE = {}));
var SHARE_STATUS;
(function (SHARE_STATUS) {
    SHARE_STATUS["IS_SHARED"] = "IS_SHARED";
    SHARE_STATUS["NOT_SHARED"] = "NOT_SHARED";
})(SHARE_STATUS = exports.SHARE_STATUS || (exports.SHARE_STATUS = {}));
var SHARE_TYPE;
(function (SHARE_TYPE) {
    SHARE_TYPE["DOCUMENT_VERSION"] = "DOCUMENT_VERSION";
    SHARE_TYPE["RECORDING"] = "RECORDING";
    SHARE_TYPE["ATTACHED_FILE"] = "ATTACHED_FILE";
    SHARE_TYPE["HUB"] = "HUB";
    SHARE_TYPE["CUSTOM_DECK"] = "CUSTOM_DECK";
})(SHARE_TYPE = exports.SHARE_TYPE || (exports.SHARE_TYPE = {}));
var SHARE_NOTIFICATION_SCOPE;
(function (SHARE_NOTIFICATION_SCOPE) {
    SHARE_NOTIFICATION_SCOPE["EMAIL"] = "EMAIL";
    SHARE_NOTIFICATION_SCOPE["NONE"] = "NONE";
})(SHARE_NOTIFICATION_SCOPE = exports.SHARE_NOTIFICATION_SCOPE || (exports.SHARE_NOTIFICATION_SCOPE = {}));
var LOG_LEVEL;
(function (LOG_LEVEL) {
    LOG_LEVEL["WARNING"] = "WARNING";
    LOG_LEVEL["ERROR"] = "ERROR";
    LOG_LEVEL["SUCCESS"] = "SUCCESS";
    LOG_LEVEL["INFO"] = "INFO";
})(LOG_LEVEL = exports.LOG_LEVEL || (exports.LOG_LEVEL = {}));
var INTEGRATION_RUN_STATUS;
(function (INTEGRATION_RUN_STATUS) {
    INTEGRATION_RUN_STATUS["RUNNING"] = "RUNNING";
    INTEGRATION_RUN_STATUS["COMPLETED"] = "COMPLETED";
    INTEGRATION_RUN_STATUS["WARNING"] = "WARNING";
    INTEGRATION_RUN_STATUS["ERROR"] = "ERROR";
})(INTEGRATION_RUN_STATUS = exports.INTEGRATION_RUN_STATUS || (exports.INTEGRATION_RUN_STATUS = {}));
var CONTENT_PRESENTED_STATUS;
(function (CONTENT_PRESENTED_STATUS) {
    CONTENT_PRESENTED_STATUS["ACTIVE"] = "ACTIVE";
    CONTENT_PRESENTED_STATUS["DELETED"] = "DELETED";
})(CONTENT_PRESENTED_STATUS = exports.CONTENT_PRESENTED_STATUS || (exports.CONTENT_PRESENTED_STATUS = {}));
var MEETING_CONTENT_TYPE;
(function (MEETING_CONTENT_TYPE) {
    MEETING_CONTENT_TYPE["CUSTOM_DECK"] = "CUSTOM_DECK";
    MEETING_CONTENT_TYPE["DOCUMENT_VERSION"] = "DOCUMENT_VERSION";
    MEETING_CONTENT_TYPE["DOCUMENT_VERSION_GROUP"] = "DOCUMENT_VERSION_GROUP";
})(MEETING_CONTENT_TYPE = exports.MEETING_CONTENT_TYPE || (exports.MEETING_CONTENT_TYPE = {}));
var SENTIMENT;
(function (SENTIMENT) {
    SENTIMENT["POSITIVE"] = "POSITIVE";
    SENTIMENT["NEGATIVE"] = "NEGATIVE";
})(SENTIMENT = exports.SENTIMENT || (exports.SENTIMENT = {}));
var MEETING_TYPE;
(function (MEETING_TYPE) {
    MEETING_TYPE["IN_PERSON"] = "IN_PERSON";
    MEETING_TYPE["VIRTUAL"] = "VIRTUAL";
    MEETING_TYPE["MANUAL"] = "MANUAL";
})(MEETING_TYPE = exports.MEETING_TYPE || (exports.MEETING_TYPE = {}));
var MEETING_STATUS;
(function (MEETING_STATUS) {
    MEETING_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
    MEETING_STATUS["ENDED_EXIT"] = "ENDED_EXIT";
    MEETING_STATUS["ENDED_TIMEOUT"] = "ENDED_TIMEOUT";
    MEETING_STATUS["DELETED"] = "DELETED";
    MEETING_STATUS["LOCKED"] = "LOCKED";
    MEETING_STATUS["PLANNED"] = "PLANNED";
})(MEETING_STATUS = exports.MEETING_STATUS || (exports.MEETING_STATUS = {}));
var MEETING_ATTENDEE_STATUS;
(function (MEETING_ATTENDEE_STATUS) {
    MEETING_ATTENDEE_STATUS["ACTIVE"] = "ACTIVE";
    MEETING_ATTENDEE_STATUS["REMOVED"] = "REMOVED";
})(MEETING_ATTENDEE_STATUS = exports.MEETING_ATTENDEE_STATUS || (exports.MEETING_ATTENDEE_STATUS = {}));
var ATTENDEE_TYPE;
(function (ATTENDEE_TYPE) {
    ATTENDEE_TYPE["PRIMARY"] = "PRIMARY";
    ATTENDEE_TYPE["SECONDARY"] = "SECONDARY";
    ATTENDEE_TYPE["CRM_USER"] = "CRM_USER";
})(ATTENDEE_TYPE = exports.ATTENDEE_TYPE || (exports.ATTENDEE_TYPE = {}));
var HUB_STATUS;
(function (HUB_STATUS) {
    HUB_STATUS["ACTIVE"] = "ACTIVE";
    HUB_STATUS["DELETED"] = "DELETED";
})(HUB_STATUS = exports.HUB_STATUS || (exports.HUB_STATUS = {}));
var HUB_SECTION_STATUS;
(function (HUB_SECTION_STATUS) {
    HUB_SECTION_STATUS["ACTIVE"] = "ACTIVE";
    HUB_SECTION_STATUS["DELETED"] = "DELETED";
})(HUB_SECTION_STATUS = exports.HUB_SECTION_STATUS || (exports.HUB_SECTION_STATUS = {}));
var HUB_SHARED_FILE_CONTENT_TYPE;
(function (HUB_SHARED_FILE_CONTENT_TYPE) {
    HUB_SHARED_FILE_CONTENT_TYPE["DOCUMENT_VERSION"] = "DOCUMENT_VERSION";
})(HUB_SHARED_FILE_CONTENT_TYPE = exports.HUB_SHARED_FILE_CONTENT_TYPE || (exports.HUB_SHARED_FILE_CONTENT_TYPE = {}));
var TODO_STATUS;
(function (TODO_STATUS) {
    TODO_STATUS["ACTIVE"] = "ACTIVE";
    TODO_STATUS["COMPLETED"] = "COMPLETED";
    TODO_STATUS["DELETED"] = "DELETED";
})(TODO_STATUS = exports.TODO_STATUS || (exports.TODO_STATUS = {}));
var HUB_TYPE;
(function (HUB_TYPE) {
    HUB_TYPE["STANDALONE"] = "STANDALONE";
    HUB_TYPE["TEMPLATE_INSTANCE"] = "TEMPLATE_INSTANCE";
    HUB_TYPE["TEMPLATE"] = "TEMPLATE";
})(HUB_TYPE = exports.HUB_TYPE || (exports.HUB_TYPE = {}));
var CUSTOM_FORM_RECORD_ENTITY;
(function (CUSTOM_FORM_RECORD_ENTITY) {
    CUSTOM_FORM_RECORD_ENTITY["BEACON_TENANT_FORM"] = "BEACON_TENANT_FORM";
    CUSTOM_FORM_RECORD_ENTITY["CRM_OBJECT"] = "CRM_OBJECT";
    CUSTOM_FORM_RECORD_ENTITY["SURVEY_TARGET"] = "SURVEY_TARGET";
})(CUSTOM_FORM_RECORD_ENTITY = exports.CUSTOM_FORM_RECORD_ENTITY || (exports.CUSTOM_FORM_RECORD_ENTITY = {}));
var CUSTOM_FORM_RECORD_STATUS;
(function (CUSTOM_FORM_RECORD_STATUS) {
    CUSTOM_FORM_RECORD_STATUS["ACTIVE"] = "ACTIVE";
    CUSTOM_FORM_RECORD_STATUS["LOCKED"] = "LOCKED";
    CUSTOM_FORM_RECORD_STATUS["DELETED"] = "DELETED";
})(CUSTOM_FORM_RECORD_STATUS = exports.CUSTOM_FORM_RECORD_STATUS || (exports.CUSTOM_FORM_RECORD_STATUS = {}));
var CUSTOM_FORM_RECORD_RELATIONSHIP_MODEL;
(function (CUSTOM_FORM_RECORD_RELATIONSHIP_MODEL) {
    CUSTOM_FORM_RECORD_RELATIONSHIP_MODEL["MEETING"] = "MEETING";
})(CUSTOM_FORM_RECORD_RELATIONSHIP_MODEL = exports.CUSTOM_FORM_RECORD_RELATIONSHIP_MODEL || (exports.CUSTOM_FORM_RECORD_RELATIONSHIP_MODEL = {}));
var PROMPT_TYPE;
(function (PROMPT_TYPE) {
    PROMPT_TYPE["DECK_COMPLIANCE_RULE"] = "DECK_COMPLIANCE_RULE";
    PROMPT_TYPE["TENANT_BACKGROUND"] = "TENANT_BACKGROUND";
    PROMPT_TYPE["AI_SUMMARY_DOC_TYPE"] = "AI_SUMMARY_DOC_TYPE";
    PROMPT_TYPE["AI_SUMMARY_INSTRUCTIONS"] = "AI_SUMMARY_INSTRUCTIONS";
    PROMPT_TYPE["AI_SEARCH_ABBREVIATIONS"] = "AI_SEARCH_ABBREVIATIONS";
})(PROMPT_TYPE = exports.PROMPT_TYPE || (exports.PROMPT_TYPE = {}));
var PROMPT_STATUS;
(function (PROMPT_STATUS) {
    PROMPT_STATUS["ACTIVE"] = "ACTIVE";
    PROMPT_STATUS["DELETED"] = "DELETED";
})(PROMPT_STATUS = exports.PROMPT_STATUS || (exports.PROMPT_STATUS = {}));
var BULLETIN_STATUS;
(function (BULLETIN_STATUS) {
    BULLETIN_STATUS["DRAFT"] = "DRAFT";
    BULLETIN_STATUS["ACTIVE"] = "ACTIVE";
    BULLETIN_STATUS["DELETED"] = "DELETED";
})(BULLETIN_STATUS = exports.BULLETIN_STATUS || (exports.BULLETIN_STATUS = {}));
var ATTACHED_FILE_ENTITY_TYPE;
(function (ATTACHED_FILE_ENTITY_TYPE) {
    ATTACHED_FILE_ENTITY_TYPE["DOCUMENT_VERSION"] = "DOCUMENT_VERSION";
    ATTACHED_FILE_ENTITY_TYPE["EMAIL_TEMPLATE"] = "EMAIL_TEMPLATE";
})(ATTACHED_FILE_ENTITY_TYPE = exports.ATTACHED_FILE_ENTITY_TYPE || (exports.ATTACHED_FILE_ENTITY_TYPE = {}));
var FORCE_PROPERTY_UPDATE;
(function (FORCE_PROPERTY_UPDATE) {
    FORCE_PROPERTY_UPDATE["OVERRIDE"] = "OVERRIDE";
    FORCE_PROPERTY_UPDATE["POPULATE"] = "POPULATE";
})(FORCE_PROPERTY_UPDATE = exports.FORCE_PROPERTY_UPDATE || (exports.FORCE_PROPERTY_UPDATE = {}));
var DOCUMENT_MAPPING_ACTION;
(function (DOCUMENT_MAPPING_ACTION) {
    DOCUMENT_MAPPING_ACTION["LINK"] = "LINK";
    DOCUMENT_MAPPING_ACTION["UNLINK"] = "UNLINK";
})(DOCUMENT_MAPPING_ACTION = exports.DOCUMENT_MAPPING_ACTION || (exports.DOCUMENT_MAPPING_ACTION = {}));
var DOCUMENT_MAPPING_STATUS;
(function (DOCUMENT_MAPPING_STATUS) {
    DOCUMENT_MAPPING_STATUS["READY"] = "READY";
    DOCUMENT_MAPPING_STATUS["SUCCEEDED"] = "SUCCEEDED";
    DOCUMENT_MAPPING_STATUS["PARTIAL"] = "PARTIAL";
    DOCUMENT_MAPPING_STATUS["NO_CHANGE"] = "NO_CHANGE";
})(DOCUMENT_MAPPING_STATUS = exports.DOCUMENT_MAPPING_STATUS || (exports.DOCUMENT_MAPPING_STATUS = {}));
var TENANT_LOGO_VARIANCE;
(function (TENANT_LOGO_VARIANCE) {
    TENANT_LOGO_VARIANCE["PRIMARY"] = "PRIMARY";
    TENANT_LOGO_VARIANCE["HUB"] = "HUB";
})(TENANT_LOGO_VARIANCE = exports.TENANT_LOGO_VARIANCE || (exports.TENANT_LOGO_VARIANCE = {}));
var LangflowStatus;
(function (LangflowStatus) {
    LangflowStatus["SUCCESS"] = "SUCCESS";
    LangflowStatus["ERROR"] = "ERROR";
    LangflowStatus["INFO"] = "INFO";
})(LangflowStatus = exports.LangflowStatus || (exports.LangflowStatus = {}));
var ModelSortDirection;
(function (ModelSortDirection) {
    ModelSortDirection["ASC"] = "ASC";
    ModelSortDirection["DESC"] = "DESC";
})(ModelSortDirection = exports.ModelSortDirection || (exports.ModelSortDirection = {}));
var ZENDESK_FEATURE;
(function (ZENDESK_FEATURE) {
    ZENDESK_FEATURE["CHAT"] = "CHAT";
    ZENDESK_FEATURE["SSO"] = "SSO";
})(ZENDESK_FEATURE = exports.ZENDESK_FEATURE || (exports.ZENDESK_FEATURE = {}));
var RelatedSlidePageType;
(function (RelatedSlidePageType) {
    RelatedSlidePageType["COVER"] = "COVER";
    RelatedSlidePageType["AGENDA"] = "AGENDA";
    RelatedSlidePageType["CONTENT"] = "CONTENT";
    RelatedSlidePageType["CLINICAL_DATA"] = "CLINICAL_DATA";
    RelatedSlidePageType["SAFETY_INFORMATION"] = "SAFETY_INFORMATION";
    RelatedSlidePageType["BIBLIOGRAPHY"] = "BIBLIOGRAPHY";
    RelatedSlidePageType["APPENDIX"] = "APPENDIX";
    RelatedSlidePageType["OTHER"] = "OTHER";
})(RelatedSlidePageType = exports.RelatedSlidePageType || (exports.RelatedSlidePageType = {}));
//# sourceMappingURL=API.js.map